import Spinner from "react-bootstrap/Spinner";

interface Props {
    loading: boolean;
    style?: any
    className?: string
}

export const LoadingIndicator = ({ loading, style, className }: Props) => {
    return (
        <>
            {loading && (
                <div
                    className={className}
                    style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        ...style
                    }}
                >
                    <Spinner animation="border" role="status" variant="dark" />
                </div>
            )}
        </>
    );
};
